"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProfileView = ProfileView;
var _litHtml = require("lit-html");
var _solidLogic = require("solid-logic");
require("./ProfileView.css");
require("./styles/CollapsibleSection.css");
var _ProfileViewModelPresenter = require("./ProfileViewModelPresenter");
var _ContactInfoSection = require("./sections/contactInfo/ContactInfoSection");
var _LanguageSection = require("./sections/languages/LanguageSection");
var _SkillsSection = require("./sections/skills/SkillsSection");
var _ResumeSection = require("./sections/resume/ResumeSection");
var _ProjectSection = require("./sections/projects/ProjectSection");
var _HeadingSection = require("./sections/heading/HeadingSection");
var _BioSection = require("./sections/bio/BioSection");
var _SocialSection = require("./sections/social/SocialSection");
var _QRCodeSection = require("./sections/qrcode/QRCodeSection");
function getViewerMode(subject) {
  let mode = 'anonymous';
  if (_solidLogic.authn.currentUser() && _solidLogic.authn.currentUser().sameTerm(subject)) mode = 'owner';
  if (_solidLogic.authn.currentUser() && !_solidLogic.authn.currentUser().sameTerm(subject)) mode = 'authenticated';
  return mode;
}
function renderSidebar(store, subject, accounts, skills, languages, contactInfo, viewerMode, onSaved) {
  return (0, _litHtml.html)`
    <div
      class="profile__sidebar"
    >
      <aside class="profile__sidebar-content" aria-labelledby="profile-sidebar-heading">
        <h2 id="profile-sidebar-heading" class="sr-only">Profile sidebar</h2>
        ${(0, _SocialSection.renderSocialSection)(store, subject, accounts, viewerMode, onSaved)}
        ${(0, _SkillsSection.renderSkillsSection)(store, subject, skills, viewerMode, onSaved)}
        ${(0, _LanguageSection.renderLanguageSection)(store, subject, languages, viewerMode, onSaved)}
        ${(0, _ContactInfoSection.renderContactInfoSection)(store, subject, contactInfo, viewerMode, onSaved)}
        ${(0, _QRCodeSection.renderQRCodeSection)(subject, store)}
      </aside>
    </div>
  `;
}
async function ProfileView(subject, context, onSaved) {
  const store = context.session.store;
  const viewerMode = getViewerMode(subject);
  const layout = context.environment?.layout ?? 'desktop';
  const theme = context.environment?.theme ?? 'light';
  const inputMode = context.environment?.inputMode ?? 'pointer';
  const viewModel = await (0, _ProfileViewModelPresenter.presentProfileViewModel)(subject, store);
  const profileDetails = viewModel.profileDetails;
  const rolesByType = viewModel.cvDetails;
  const skills = viewModel.skills;
  const languages = viewModel.languages;
  const projects = viewModel.projects;
  const bioDetails = viewModel.bioDetails;
  const accounts = viewModel.social;
  const contactInfo = viewModel.contactInfo;
  const headingSection = await (0, _HeadingSection.renderHeadingSection)(context, subject, profileDetails, viewerMode, onSaved);
  const bioSection = (0, _BioSection.renderBioSection)(store, subject, bioDetails, viewerMode, onSaved);
  const skillsSection = (0, _SkillsSection.renderSkillsSection)(store, subject, skills, viewerMode, onSaved);
  const languageSection = (0, _LanguageSection.renderLanguageSection)(store, subject, languages, viewerMode, onSaved);
  const cvSection = (0, _ResumeSection.renderCVSection)(store, subject, rolesByType, viewerMode, onSaved);
  const projectSection = (0, _ProjectSection.renderProjectSection)(store, subject, projects, viewerMode, onSaved);
  const socialSection = (0, _SocialSection.renderSocialSection)(store, subject, accounts, viewerMode, onSaved);
  const contactInfoSection = (0, _ContactInfoSection.renderContactInfoSection)(store, subject, contactInfo, viewerMode, onSaved);
  const qrCodeSection = (0, _QRCodeSection.renderQRCodeSection)(subject, store);
  if (layout === 'mobile') {
    return (0, _litHtml.html)`
      <div
        class="profile-pane-root"
        data-layout=${layout}
        data-theme=${theme}
        data-input-mode=${inputMode}
      >
        <main
          id="main-content"
          class="profile-grid"
          tabindex="-1"
        >
          ${headingSection}
          ${bioSection}
          ${skillsSection}
          ${languageSection}
          ${cvSection}
          ${projectSection}
          ${socialSection}
          ${contactInfoSection}
          ${qrCodeSection}
        </main>
      </div>
    `;
  }
  return (0, _litHtml.html)`
    <div
      class="profile-pane-root"
      data-layout=${layout}
      data-theme=${theme}
      data-input-mode=${inputMode}
    >
      <div
        id="main-content"
        class="profile-grid"
        tabindex="-1"
      >

        <section class="profile__main">
          ${headingSection}
          ${bioSection}
          ${cvSection}
          ${projectSection}

        </section>
        ${renderSidebar(store, subject, accounts, skills, languages, contactInfo, viewerMode, onSaved)}
      </div>
    </div>
  `;
}